import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Logo } from '../../reusable-components/logo';
// ----------------------------------------------------------------------

const StyledHeader = styled('header')(({ theme }) => ({
  top: 16,
  left: 48,
  lineHeight: 0,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    padding: theme.spacing(3, 3, 0),
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: 20,
    marginLeft: 10,
    marginBottom: 8
  },
}));

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  return (
    <>
      <StyledHeader position="fixed">
        <Logo />
      </StyledHeader>
      <Outlet />
    </>
  );
}
